module.exports = __webpack_public_path__ + "static/media/traslados.496a5cbd.svg";